import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthFullScreenSignIn() {
	return <AuthShell variant="full-screen"><AuthForm variant="full-screen" mode="sign-in" /></AuthShell>;
}

export default AuthFullScreenSignIn;
